// extracted by mini-css-extract-plugin
module.exports = {"row":"CleaningList_row__3Ou0T","nocleaning":"CleaningList_nocleaning__VbCfh"};